<template>
    <div id="app">
        <v-app id="inspire">
            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="250">
                <v-container>
                    <v-layout>
                        <h4 class="subheading font-weight-medium">SERVICE MENU</h4>
                        <v-spacer></v-spacer>
                        <h4 class="subheading font-weight-medium">{{user.displayName}}</h4>
                    </v-layout>

                    <v-layout>
                        <v-container class="pr-0">
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout>
                        <v-list-tile @click="watchMenu='active'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Active</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="activeColor"><b>{{serviceMenu.length}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile @click="watchMenu='inactive'"> 
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Inactive</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="inactiveColor"><b>{{inactiveServices.length}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-spacer></v-spacer>
                        <v-btn color="red accent-4" dark @click="syncDialog=true">SYNC<v-icon small>sync</v-icon></v-btn>
                        <v-btn color="blue-grey" dark @click="addServiceDialog=true">ADD SERVICE</v-btn>
                    </v-layout>

                </v-container>
            </v-parallax>

            <v-layout>
                <v-container>
                <v-flex xs12>
                    <v-data-table v-if="watchMenu=='active'" :search="search" :headers="headers" :items="serviceMenu" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.index }}</td>
                            <td class="text-xs-left">{{ props.item.serviceName }}</td>
                            <td class="text-xs-left">{{ props.item.category }}</td>
                            <td class="text-xs-left">{{ props.item.description }}</td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='CUB'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Business'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Automatic'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Off-Road'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Hi-End'">
                                {{ list.time }}
                            </td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item), updateServiceDialog=true">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Service Menu
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>

                    <v-data-table v-if="watchMenu=='inactive'" :search="search" :headers="headers" :items="inactiveServices" class="elevation-1">
                        <template v-slot:items="props">
                            <td>{{ props.item.index }}</td>
                            <td class="text-xs-left">{{ props.item.serviceName }}</td>
                            <td class="text-xs-left">{{ props.item.category }}</td>
                            <td class="text-xs-left">{{ props.item.description }}</td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='CUB'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Business'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Automatic'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Off-Road'">
                                {{ list.time }}
                            </td>
                            <td class="text-xs-left" v-for="(list, index) in props.item.classifications" :key="index" v-if="list.class=='Hi-End'">
                                {{ list.time }}
                            </td>
                            <td class="justify-center">
                                <v-icon small @click="requestForChange(props.item), updateServiceDialog=true">edit</v-icon>
                            </td>
                        </template> 
                        <template v-slot:no-data>
                            <v-alert :value="true" color="grey">
                                No Service Menu
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
                </v-container>
            </v-layout>

            <v-layout>
                <v-dialog v-model="addServiceDialog" persistent max-width="80%">
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="70">
                            <v-container>
                                <v-layout>
                                    <h4 class="subheading font-weight-medium">ADD SERVICE</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                            <v-container>
                                <v-layout row wrap>
                                    <v-container class="pt-0">
                                        <v-flex xs12>
                                            <v-text-field label="Service Number*" type="number" v-model='itemIndex'></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field label="Service Name*" v-model='serviceName'></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-select label="Category*" :items="categories" v-model='category'></v-select>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="serviceDescription" label="Service Description*" persistent-hint leave-absolute>
                                            </v-text-field>
                                        </v-flex>

                                        <v-card-text class="title font-weight-medium pl-0 pb-0 pt-3">FRT</v-card-text>

                                        <v-flex xs12>
                                            <v-select v-for="(item,index) in classifications" :key="index"
                                            :label="item.classification" :items="flatRate" 
                                            @change="setServiceClassificationTime(item.classification, $event)">
                                            </v-select>
                                        </v-flex>

                                        <v-layout justify-end>
                                            <v-btn color="red accent-4" dark @click="reload()">CANCEL</v-btn>
                                            <v-btn color="blue accent-4" dark @click="saveServiceMenu()">SAVE</v-btn>
                                        </v-layout>

                                    </v-container>
                                </v-layout>
                            </v-container>
                        </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="updateServiceDialog" persistent max-width="80%">
                    <v-card>
                        <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="70">
                            <v-container>
                                <v-layout>
                                    <h4 class="subheading font-weight-medium">UPDATE SERVICE</h4>
                                </v-layout>
                            </v-container>
                        </v-parallax>

                        <v-container grid-list>
                            <v-container>
                                <v-layout row wrap>
                                    <v-container class="pt-0">
                                        <v-flex xs12>
                                            <v-text-field label="Service Number*" type="number" v-model='forChangeService.index'></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field label="Service Name*" v-model='forChangeService.serviceName'></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-select label="Category*" :items="categories" v-model='forChangeService.category'></v-select>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="forChangeService.description" label="Service Description*" persistent-hint leave-absolute>
                                            </v-text-field>
                                        </v-flex>

                                        <v-card-text class="title font-weight-medium pl-0 pb-0 pt-3">FRT</v-card-text>

                                        <v-flex xs12>
                                            <v-select v-for="(item,index) in forChangeService.classifications" :key="index"
                                            :label="item.class" :items="flatRate" :value="item.time"
                                            @change="updateServiceClassificationTime(item.class, $event)">
                                            </v-select>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-radio-group v-model="forChangeService.status" :mandatory="false" row>
                                                <v-radio label="Active" color="success" value="active"></v-radio>
                                                <v-radio label="Inactive" color="orange darken-4" value="inactive"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                        <br>

                                        <v-layout justify-end>
                                            <v-btn color="red accent-4" dark @click="reload()">CANCEL</v-btn>
                                            <v-btn color="blue accent-4" dark @click="updateServiceMenu()">UPDATE</v-btn>
                                        </v-layout>
                                    </v-container>
                                </v-layout>
                            </v-container>
                        </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="syncDialog" max-width="500px">
                    <v-card>
                    <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="80">
                    <v-spacer></v-spacer>
                        <v-container>
                            <v-layout><br>
                            <h4 class="title font-weight-medium">Are you sure you want to reset the current list of service menu? </h4>
                            </v-layout>
                        </v-container>
                    </v-parallax>

                    <v-container grid-list>
                        <v-card-text class="subheading font-weight-regular">
                        You are about to reset the list of current service menu that will load the default data of services.
                        </v-card-text>
                        <v-card-text class="subheading font-weight-regular">
                        Do you want to proceed?
                        </v-card-text>

                        <v-card-actions class="justify-center">
                            <v-btn dark color="red accent-4" @click="syncDialog=false">NO</v-btn>
                            <v-btn dark color="blue darken-4" @click="(syncDialog=false),syncServiceMenu()">YES</v-btn>
                        </v-card-actions>
                    </v-container>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="progressDialog" persistent width="300">
                    <v-card :color="progressColor">
                        <v-card-text class="subheading white--text">{{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>

                <v-snackbar v-model="snackbar" bottom right :color="snackbarColor" :timeout=3000>
                    {{snackbarMessage}} 
                    <v-btn dark small flat @click="snackbar = false">Close</v-btn>
                </v-snackbar>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import firebase from "firebase"
import firebaseui from "firebaseui"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { config } from "../firebaseConfig"
import router from '../router'
import { db } from '../main.js'
import { mapGetters, mapActions } from "vuex"
import store from '../stores'
import moment from 'moment'
import _ from 'lodash'

export default {
    data() {
        return {
            id: "",
            classifications: [],
            serviceMenu: [],
            inactiveServices: [],
            itemIndex: 0,
            serviceName: "",
            serviceDescription: "",
            status: "active",
            headers: [
                { text: 'Service Number',  align: 'left', sortable: true, value: 'index'},
                { text: 'Service',  align: 'left', sortable: true, value: 'serviceName'},
                { text: 'Category',  align: 'left', sortable: true, value: 'category'},
                { text: 'Description',  align: 'left', sortable: true, value: 'description'},
                { text: 'CUB',  align: 'left', sortable: true},
                { text: 'Business',  align: 'left', sortable: true },
                { text: 'Automatic',  align: 'left', sortable: true },
                { text: 'Off-Road',  align: 'left', sortable: true },
                { text: 'Hi-End',  align: 'left', sortable: true },
                { text: 'Action',  align: 'left', sortable: true }
            ],
            search: "",
            progressDialog: false,
            progressMessage: "",
            progressColor: "primary",
            snackbar: false,
            snackbarMessage: "",
            snackbarColor: "",
            addServiceDialog: false,
            updateServiceDialog: false,
            flatRate: [],
            forChangeService: {},
            service: {
                classifications: [
                    {
                        class: "CUB",
                        time: 0
                    },
                    {
                        class: "Business",
                        time: 0
                    },
                    {
                        class: "Automatic",
                        time: 0
                    },
                    {
                        class: "Off-Road",
                        time: 0
                    },
                    {
                        class: "Hi-End",
                        time: 0
                    }
                ]
            },
            categories: [],
            category: "",
            watchMenu: "active",
            activeColor: "red",
            inactiveColor: "grey",
            syncDialog: false,
        }
    },

    methods: {
        reload() {
            window.location.reload()
        }, 

        updateServiceClassificationTime(classification, event) {
            let self = this
            let index = self.forChangeService.classifications.map(c => c.class).indexOf(classification)
            self.forChangeService.classifications[index].time = event
        },

        setServiceClassificationTime(classification, event) {
            let self = this
            let index = self.service.classifications.map(c => c.class).indexOf(classification)
    
            if(index < 0) {
                self.service.classifications.push({
                    class: classification,
                    time: event
                })
            } else { 
                self.service.classifications[index].time = event
            }
        },

        requestForChange(service){
            let self = this
            self.forChangeService = service
        },

        updateServiceMenu(){
            let self = this
            if (self.forChangeService) {
                self.progressMessage = "Updating.."
                self.progressColor = "primary"
                self.progressDialog = true
                db.collection("ServiceMenu"+self.$stage).doc(self.forChangeService.id).update({
                    index: Number(self.forChangeService.index),
                    serviceName: self.forChangeService.serviceName,
                    category: self.forChangeService.category,
                    description: self.forChangeService.description,
                    classifications: self.forChangeService.classifications,
                    modifiedDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                    status: self.forChangeService.status
                }).then(function() {
                    self.progressDialog = false
                    self.snackbarMessage = "Updated"
                    self.snackbarColor = "success"
                    self.snackbar = true
                    setTimeout(() => {
                        window.location.reload()
                    }, 500)
                }).catch(function(error){
                    console.log(error)
                    self.snackbarMessage = "Error updating document"
                    self.snackbarColor = "error"
                    self.snackbar = true
                })
            }
        },

        saveServiceMenu() {
            let self = this
            
            if (self.serviceName === "" || self.serviceDescription === "" || self.category === "") {
                self.snackbarColor = error
                self.snackbarMessage = "Please fill-up details"
                self.snackbar = true
            } else {
                self.progressMessage = "Saving..."
                self.progressColor = "primary"
                self.progressDialog = true
                self.id = new Date().getTime().toString()

                db.collection("ServiceMenu"+self.$stage).doc(self.id).set({
                    id: self.id,
                    index: Number(self.itemIndex),
                    serviceName: self.serviceName,
                    category: self.category,
                    description: self.serviceDescription, 
                    classifications: self.service.classifications,
                    creationDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                    modifiedDate: "",
                    status: "active"
                }).then(function(){
                    self.progressDialog = false
                    self.snackbarMessage = "Save"
                    self.snackbarColor = "success"
                    self.snackbar = true
                    self.addServiceDialog = false
                    setTimeout(() => {
                        window.location.reload()
                    }, 500)
                }).catch(function(error) {
                    console.log(error)
                    self.snackbarMessage = "Error saving document"
                    self.snackbarColor = "error"
                    self.snackbar = true
                })
            }
        },

        syncServiceMenu() {
            let self = this
            self.serviceMenu = []
            self.inactiveServices = []
            self.progressMessage = "Syncing and update..."
            self.progressDialog = true
            db.collection('ServiceMenu').get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    } else {
                        self.inactiveServices.push(doc.data())
                    }
                })
            }).then(function(){
                self.serviceMenu.forEach(function(result){
                    db.collection("ServiceMenu"+self.$stage).doc(result.id).set({
                        classifications: result.classifications,
                        creationDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                        category: result.category,
                        description: result.description,
                        id: result.id,
                        index: result.index,
                        modifiedDate: "",
                        serviceName: result.serviceName,
                        status: result.status
                    }).then(function(){
                        self.serviceMenu.sort()
                        self.inactiveServices.sort()
                        self.progressDialog = false
                    }).catch(function(error){
                        console.log(error)
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Error Cloning document"
                        self.snackbar = true
                    })
                })
            }).catch(function(error){
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Error Syncing document"
                self.snackbar = true
            })
        },

        async fetchServiceMenu() {
            let self = this
            self.serviceMenu = []
            self.inactiveServices = []
            self.progressMessage = "Loading..."
            self.progressDialog = true
            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    } else {
                        self.inactiveServices.push(doc.data())
                    }   
                })
            }).then(function(){
                self.serviceMenu.sort()
                self.inactiveServices.sort()
                self.progressDialog = false
            }).catch(function(error){
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Error Fetching document"
                self.snackbar = true
            })
        },

        async fetchClassification() {
            let self = this    
            self.classifications = []

            await db.collection("Settings"+self.$stage).doc("Classification")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Classification should be set"
                        self.snackbar = true
                    } else {
                        self.classifications.push(doc.data())
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Classification should be set"
                self.snackbar = true
            })
        },

        async fetchFlatRate() {
            let self = this    
            self.flatRate = []
            let count = 0

            await db.collection("Settings"+self.$stage).doc("FlatRate")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    count ++
                    if (!doc.exists) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Flat Rate should be set"
                        self.snackbar = true
                    } else {
                        self.flatRate.push(doc.data().time)
                    }

                    if (count === querySnapshot.docs.length) {
                        self.flatRate.sort(function(a, b){return a-b})
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Flat Rate should be set"
                self.snackbar = true
            })
        },

        async fetchCategories() {
            let self = this    
            self.categories = []

            await db.collection("Settings"+self.$stage).doc("Categories")
            .collection("Items").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (!doc.exists) {
                        self.snackbarColor = "error"
                        self.snackbarMessage = "Categories should be set"
                        self.snackbar = true
                    } else {
                        self.categories.push(doc.data().category)
                    }
                })
            }).catch(function(error) {
                console.log(error)
                self.snackbarColor = "error"
                self.snackbarMessage = "Categories should be set"
                self.snackbar = true
            })
        },
    },

    mounted () {
        this.fetchClassification()
        this.fetchServiceMenu()
        this.fetchCategories()
        this.fetchFlatRate()
    },

    computed : {
        ...mapGetters(["user"]),
    },

    watch: {
        watchMenu(val) {
            if(this.watchMenu == "active"){
                this.activeColor = "red"
                this.inactiveColor = "grey"
            } else if(this.watchMenu == "inactive"){
                this.activeColor = "grey"
                this.inactiveColor = "red"
            }
        },
    },
}
</script>


